import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import './index.scss';
import './custom.scss';

import App from './App';
import configureStore from './ducks/configureStore';
import * as serviceWorker from './serviceWorker';

const win = window as Win;
const searchParams = new URLSearchParams(win.location.search);
const moduleId =
  searchParams && searchParams.has('moduleId') ? searchParams.get('moduleId') : win.globalModuleId;
const slideIncluded =
  searchParams && searchParams.has('slideIncluded') ? !!searchParams.get('slideIncluded') : false;

const AppWithProvider = () => {
  if (moduleId || slideIncluded) {
    const store = configureStore();

    // Dev
    if (
      process.env.NODE_ENV === 'development' &&
      window.origin &&
      window.origin.includes('localhost')
    ) {
      console.log('Initial redux state:', store.getState());
      store.subscribe(() => {
        console.log('State after dispatch:', store.getState());
      });
    }

    // Get the site head, create a script element for FontAwesome, and prepend it to the head
    const head = document.getElementsByTagName('head')[0];
    const script = document.createElement('script');
    script.setAttribute('src', 'https://use.fontawesome.com/releases/v5.15.4/js/all.js');
    script.setAttribute('data-auto-replace-svg', 'nest');
    head.prepend(script);

    // If Start is defined, then we are in Litmos, so start the SCORM API
    // and inject the css
    if (win.Start) {
      win.Start();
    }

    return (
      <Provider store={store}>
        <App />
      </Provider>
    );
  }

  return (
    <div>
      <h2 className="invalid-browser-text">
        Not enough information provided to load. Check the URL.
      </h2>
    </div>
  );
};

ReactDOM.render(
  <React.StrictMode>
    <AppWithProvider />
  </React.StrictMode>,
  document.getElementById('app'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
